import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getAgreementPolicies(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.AGREEMENT_POLICIES.GET_AGREEMENT_POLICIES, action.payload, true);
}

export function* deleteAgreementPolicy(action: any): any {
    const {id} = action.payload;
    const urlWithQuery = `${APIS.AGREEMENT_POLICIES.DELETE_AGREEMENT_POLICY}?id=${id}`;
    yield call(sagaFunction, action, CallApi.POST, urlWithQuery, {}, true);
}

export function* insertUpdateAgreementPolicy(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.AGREEMENT_POLICIES.INSERT_UPDATE_POLICY, action.payload, true);
}

export function* getPolicyById(action: any): any {
    const {id} = action.payload;
    const urlWithQuery = `${APIS.AGREEMENT_POLICIES.GET_POLICY_BY_ID}?id=${id}`;
    // const yieldPuts = [{ type: ACTIONS.AGREEMENT_POLICIES.GET_POLICY_BY_ID, payload: "item" }];
    yield call(sagaFunction, action, CallApi.GET, urlWithQuery, {}, true);
}